import { Component, OnChanges, Input, Output, EventEmitter, OnInit, inject } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'
import { AuthenticationService } from 'app/services/auth.service';
import { NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

type optionType = {
  from?: string;
  to?: string;
  minDate: string;
  maxDate?: string;
  quickSelect: string[];
  dateRange: string;
};

export type dateChangeType = {
  from: string;
  to: string;
};

@Component({
    selector: 'DateRangePicker',
    templateUrl: './daterangepicker.component.html',
    styleUrls: ['./daterangepicker.component.scss'],
    imports: [NgbInputDatepicker, FormsModule]
})

export class DateRangePickerComponent implements OnInit, OnChanges {
  private auth = inject(AuthenticationService);

  @Input() options:optionType = {
    from : '',
    to : '',
    minDate : '',
    maxDate : '',
    quickSelect : [],
    dateRange : 'ytd'
  }
  @Output() dateChange: EventEmitter<dateChangeType>;
  public dateRange = 'ytd';
  public vd?:Date;
  public valuationDate?: NgbDateStruct;
  public startDateModel?: NgbDateStruct;
  public endDateModel?: NgbDateStruct;
  public minDateModel?: NgbDateStruct;
  public maxDateModel?: NgbDateStruct;


  constructor() {
    this.dateChange = new EventEmitter<dateChangeType>();
  }

  ngOnInit() {
    const vd = this.auth.getCurrentValuationDate();
    if (vd) {
      const d = vd.split('-');
      this.valuationDate = {year: parseInt(d[0]), month: parseInt(d[1]), day: parseInt(d[2])};
      this.vd = vd.toNWMdate();
    }
  }
  ngOnChanges(): void {
    let d: string[] = [];
    if (this.options.from) {d = this.options.from.split('-'); this.startDateModel = {year:parseInt(d[0]),month:parseInt(d[1]),day:parseInt(d[2])}; }
    if (this.options.to) {d = this.options.to.split('-'); this.endDateModel = {year:parseInt(d[0]),month:parseInt(d[1]),day:parseInt(d[2])}; }
    if (this.options.minDate) {d = this.options.minDate.split('T')[0].split('-'); this.minDateModel = {year:parseInt(d[0]),month:parseInt(d[1]),day:parseInt(d[2])}; }
    if (this.options.maxDate) {d = this.options.maxDate.split('T')[0].split('-'); this.maxDateModel = {year:parseInt(d[0]),month:parseInt(d[1]),day:parseInt(d[2])}; }
    if (this.options.dateRange) {this.onQuickSelect()}
  }

  onDateChange(quickSelect = false) {
    this.dateChange.emit({
      from: this.startDateModel!.year + '-' + this.pad(this.startDateModel!.month) + '-' + this.pad(this.startDateModel!.day),
      to: this.endDateModel!.year + '-' + this.pad(this.endDateModel!.month) + '-' + this.pad(this.endDateModel!.day)
    });
    if (!quickSelect) this.dateRange = '---';
  }

  pad(n: number) {
    return n > 99 ? n : ('0'+n).slice(-2);
  }

  onQuickSelect(emit = true) {
    let d;
    switch (this.dateRange) {
      case "---":
        return;
      case "ytd":
        this.startDateModel = {year: this.valuationDate!.year, month: 1, day: 1};
        break;
      default:
        d = new Date(this.vd!.getTime() - (+this.dateRange)*24*60*60*1000);
        this.startDateModel = {year: d.getFullYear(), month: d.getMonth()+1, day: d.getDate()};
    }
    this.endDateModel = this.valuationDate;
    if (emit) this.onDateChange(true);
  }
}
